import { render, staticRenderFns } from "./PayCreateAccountIn.vue?vue&type=template&id=ca01b3c6"
import script from "./PayCreateAccountIn.vue?vue&type=script&lang=js"
export * from "./PayCreateAccountIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports